module.exports = __webpack_public_path__ + "img/hourse_range.b83869fc.svg";